module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ab152-de7efeaebed3f7a33c2df5b3e38d2a5a.jpg";